import { SenderId } from '@/apis/core/types';
import { globalGetService, globalPutService } from '@/utils/globalApiServices';
import { Pagination } from '@/utils/types';

export const getCampaignSenderIds = async (campaignUid: string) => {
  const response = await globalGetService(
    `mno/campaigns/${campaignUid}/senderId`
  );
  return (response?.ok ? response.data : []) as SenderId[];
};

export const getSenderIds = async (queries?: Record<string, any>) => {
  const response = await globalGetService('mno/senderId', queries);
  return response?.ok ? (response.data as Pagination<SenderId>) : undefined;
};

export const suspendSenderId = async (
  inventoryUid: string,
  payload: { status: 'SUSPENDED'; message: string }
) => {
  const response = await globalPutService(
    `mno/senderId/${inventoryUid}`,
    payload
  );
  return response?.ok ? response.data : undefined;
};
